class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.triggerButtonId = this.dataset.triggerButtonId;
    this.observeTargetId = this.dataset.observeTargetId;
    this.button = this.querySelector('[data-sticky-atc-button]');
  }

  connectedCallback() {
    const target = document.getElementById(this.observeTargetId);
    if (!target || !this.button) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        // Show the sticky bar once the real Add to Cart button has scrolled
        // out of view (above the viewport); hide it while the real button is visible.
        if (entry.isIntersecting) {
          this.classList.remove('sticky-atc--visible');
        } else if (entry.boundingClientRect.top < 0) {
          this.classList.add('sticky-atc--visible');
        } else {
          this.classList.remove('sticky-atc--visible');
        }
      },
      { threshold: 0 }
    );
    this.observer.observe(target);

    this.button.addEventListener('click', this.handleClick.bind(this));
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  handleClick(event) {
    event.preventDefault();
    const realButton = document.getElementById(this.triggerButtonId);
    if (realButton && !realButton.disabled) {
      realButton.click();
    }
  }
}

customElements.define('sticky-atc', StickyAtc);
